import React from "react"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import {Trans} from "@lingui/macro";
import {LandlordDetails} from "../../../../models";

interface LandlordModalProps {
    closeLandlordModal: () => void
    landlord: LandlordDetails
}

interface LandlordModalState {

}

export class LandlordModal extends React.Component<LandlordModalProps, LandlordModalState>
{

    private getAddress = () : string => {
        let fullAddress: string = ""
        if(this.props.landlord.account.accountDetails.address){
            fullAddress += this.props.landlord.account.accountDetails.address
        }
        if(this.props.landlord.account.accountDetails.city){
            if(fullAddress===""){
                fullAddress += this.props.landlord.account.accountDetails.city
            }
            else {
                fullAddress += ", " + this.props.landlord.account.accountDetails.city
            }
        }
        if(this.props.landlord.account.accountDetails.province){
            if(fullAddress===""){
                fullAddress += this.props.landlord.account.accountDetails.province
            }
            else {
                fullAddress += ", " + this.props.landlord.account.accountDetails.province
            }
        }
        if(this.props.landlord.account.accountDetails.postalCode){
            if(fullAddress===""){
                fullAddress += this.props.landlord.account.accountDetails.postalCode
            }
            else {
                fullAddress += ", " + this.props.landlord.account.accountDetails.postalCode
            }
        }
        if(this.props.landlord.account.accountDetails.country){
            if(fullAddress===""){
                fullAddress += this.props.landlord.account.accountDetails.country
            }
            else {
                fullAddress += ", " + this.props.landlord.account.accountDetails.country
            }
        }

        return fullAddress
    }

    render(){
        return(
            <Dialog open={true} onClose={this.props.closeLandlordModal} fullWidth maxWidth={"md"}>
                <DialogTitle>
                    <Trans id={"af-landlord-modal"}>
                        Informazioni di dettaglio proprietario
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item md={12}>
                            <Typography>
                                <Trans id={"af-landlord-modal.name"}>
                                    Nome e cognome: <b>{(this.props.landlord.account.accountDetails.firstName ?? "") + " " + (this.props.landlord.account.accountDetails.lastName ?? "")}</b>
                                </Trans>
                            </Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Typography>
                                <Trans id={"af-landlord-modal.phone"}>
                                    Telefono: <b>{this.props.landlord.account.accountDetails.phone ?? ""}</b>
                                </Trans>
                            </Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Typography>
                                <Trans id={"af-landlord-modal.email"}>
                                    E-mail: <b>{this.props.landlord.account.username ?? ""}</b>
                                </Trans>
                            </Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Typography>
                                <Trans id={"af-landlord-modal.address"}>
                                    Indirizzo: <b>{this.getAddress()}</b>
                                </Trans>
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.closeLandlordModal}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 1,
                                width: 100
                            }}
                            disableElevation>
                        <Trans id={"asset-details.asset-form.close-map"}>
                            Chiudi
                        </Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
